import React from 'react';

import { DimensionValue, StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';

type CarouselBoxProps = BoxProps & {
  bgColor?: string;
  justifyContent?: 'center' | 'flex-start' | 'flex-end';
  maxWidth?: number;
};

export const Container = ({
  bgColor,
  justifyContent,
  maxWidth,
  style,
  ...props
}: CarouselBoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.container, { backgroundColor: bgColor, justifyContent, maxWidth }, style],
  });

export const MeasureBox = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.measureBox, style] });

export const CardContainerWrapper = ({
  style,
  width,
  ...props
}: BoxProps & { width?: DimensionValue }) =>
  React.createElement(Box, { ...props, style: [styles.cardContainerWrapper, { width }, style] });

type SideButtonProps = CarouselBoxProps;

const SideButtonWrapped = ({ bgColor, justifyContent, style, ...props }: SideButtonProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.sideButton, { backgroundColor: bgColor, justifyContent }, style],
  });

export const RightButtonWrapper = ({ style, ...props }: CarouselBoxProps) =>
  React.createElement(SideButtonWrapped, { ...props, style: [styles.rightButton, style] });

export const LeftButtonWrapper = ({ style, ...props }: CarouselBoxProps) =>
  React.createElement(SideButtonWrapped, { ...props, style: [styles.leftButton, style] });

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
  },
  measureBox: {
    flex: 1,
  },
  cardContainerWrapper: {
    alignSelf: 'center',
    flexDirection: 'row',
    marginBottom: 12,
  },
  sideButton: {
    alignItems: 'center',
    flexDirection: 'row',
    width: 40,
  },
  rightButton: {
    justifyContent: 'flex-end',
  },
  leftButton: {
    justifyContent: 'flex-start',
  },
});
